import { render, staticRenderFns } from "./AboutPage5.vue?vue&type=template&id=38d5afb4&scoped=true"
import script from "./AboutPage5.vue?vue&type=script&lang=js"
export * from "./AboutPage5.vue?vue&type=script&lang=js"
import style0 from "./AboutPage5.vue?vue&type=style&index=0&id=38d5afb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d5afb4",
  null
  
)

export default component.exports